/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING ANALYTICS - COMMENTING USERS REPORT : STYLES --------------- ++++++++++ */
export default {
    commentingusersreport: {
        marginBottom: pxToEm(16)
    }
};
